<template>
  <PublicPopup
    ref="DepositoPayPopupRef"
    type="fullScreen"
    position="bottom"
    close-on-click-overlay
    :closeable="false"
    height="100vh"
  >
    <template v-if="!isMX" #content>
      <div class="deposito-pay-popup">
        <van-nav-bar :title="t('deposito-index.depositoPay.title')" left-arrow @click-left="close"></van-nav-bar>

        <div class="bodyer-container">
          <div class="order-container info">
            <div class="order-num-box chxy-row-bt">
              <span class="value">{{ filterQcdoeNumShow(payInfoNew.qcdoeNum) }}</span>
              <span class="copy-icon-box" @click="clickCopyPublic(payInfoNew.qcdoeNum)">
                <img class="pay-copy" :src="getImageUrlWithCDN_LOCAL('/public/copy_default_white.svg')" />
              </span>
            </div>

            <div class="pay-num-box chxy-row-bt">
              <span class="label">{{ t('deposito-index.depositoPay.amount') }}</span>
              <span class="pay-num">{{ formatNumberWithComma(filterAmount(props.payInfo.amount) || '0.00') }}</span>
            </div>
          </div>

          <div class="order-container main">
            <div class="prompt-container">
              <p>
                {{ t('deposito-index.depositoPay.pixInstruction') }}
              </p>
              <p>
                {{ t('deposito-index.depositoPay.singleUseInstruction') }}
              </p>
            </div>

            <!-- qcdoeNum 替换为新的 qcdoeNum -->
            <div class="qr-code-container chxy-row-c-c">
              <QRCode :value="payInfoNew.qcdoeNum" :size="300" />
            </div>

            <div class="copiar-button __button_primary" @click="clickCopyPublic(payInfoNew.qcdoeNum)">
              {{ t('deposito-index.depositoPay.copyQrCode') }}
            </div>
          </div>
        </div>

        <div class="pix-icon-box chxy-row-c-c">
          <img class="pix-icon" :src="getImageUrlWithCDN_LOCAL('/deposito/pix_logo_img.webp')" />
        </div>
      </div>
    </template>
    <!-- v-if="!isMX" -->
    <template v-else #content>
      <div class="deposito-pay-popup">
        <van-nav-bar :title="t('deposito-index.depositoPay.title')" left-arrow @click-left="close"></van-nav-bar>

        <div class="pay-bg">
          <img src="/theme/pay/pay-bg.png" alt="logo" class="pay-bg-img" />
          <div class="pay-overlay">
            <div class="chxy-column-c-c pay-content">
              <div class="payment-amount-label">Importe del pago:</div>
              <div class="payment-amount-value">MX$ {{ filterAmount(props.payInfo.amount) || '0.00' }}</div>
            </div>
          </div>
        </div>

        <div class="chxy-row-bt payment-info-container" @click="clickCopyPublic(props.payInfo?.needInfo.accountNumber)">
          <div class="clabe-container">
            <div class="clabe-label">Clabe:</div>
            <div class="clabe-value">
              {{ props.payInfo?.needInfo.accountNumber || '-' }}
            </div>
          </div>
          <div class="copy-button chxy-row-c-c">
            <!-- <img src="/theme/pay/pay-copy.png" alt="logo" class="copy-icon" /> -->
            <div class="copy-text">Copiar</div>
          </div>
        </div>

        <div class="chxy-row-bt payment-info-container" @click="clickCopyPublic(props.payInfo?.needInfo.bankName)">
          <div class="clabe-container">
            <div class="clabe-label">Banco Destino:</div>
            <div class="clabe-value">
              {{ props.payInfo?.needInfo.bankName || '-' }}
            </div>
          </div>
          <div class="copy-button chxy-row-c-c">
            <!-- <img src="/theme/pay/pay-copy.png" alt="logo" class="copy-icon" /> -->
            <div class="copy-text">Copiar</div>
          </div>
        </div>

        <div class="chxy-row-bt payment-info-container m-b-5">
          <div class="clabe-container">
            <div class="clabe-label">Beneficiario:</div>
            <div class="clabe-value">{{ props.payInfo?.needInfo.accountName || '-' }}</div>
          </div>
        </div>

        <!-- 临时写，要改成数组 循环 -->
        <div class="instruction-step chxy-row-ac">
          <img src="/theme/pay/pay-copy-fff.png" alt="logo" class="instruction-icon" />
          <div class="instruction-text">
            <div class="instruction-step-label">Paso 1:</div>
            <div class="instruction-step-value">Copiar la Clabe</div>
          </div>
        </div>
        <div class="instruction-step chxy-row-ac">
          <img src="/theme/pay/pay-card.png" alt="logo" class="instruction-icon" />
          <div class="instruction-text">
            <div class="instruction-step-label">Paso 2:</div>
            <div class="instruction-step-value">Pegar la Clabe en su App bancaria e ingresar el monto a pagar.</div>
          </div>
        </div>
        <div class="instruction-step chxy-row-ac">
          <img src="/theme/pay/read-book.png" alt="logo" class="instruction-icon" />
          <div class="instruction-text">
            <div class="instruction-step-label">Paso 3:</div>
            <div class="instruction-step-value">
              Revisar que el importe sea descontado de su saldo. (Si este no es confirmado de inmediato, revisar más
              tarde)
            </div>
          </div>
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import { formatNumberWithComma } from '@/utils/format.js'
import { langEnums } from '@/utils/i18n'
import QRCode from 'qrcode.vue'
import { rechargeQueryOrderInfoApi } from '@/api/deposito'
const router = useRouter()
const { t, locale } = useI18n()
const isMX = computed(() => locale.value === langEnums.ES_MX)
const props = defineProps({
  payInfo: {
    type: Object,
    default: () => ({}),
  },
})

const DepositoPayPopupRef = ref(null)
const open = () => {
  nextTick(() => {
    console.log('props.payInfo:', props.payInfo)

    payInfoNew.value = props.payInfo
    DepositoPayPopupRef.value.open()
  })
}
const close = () => {
  nextTick(() => {
    DepositoPayPopupRef.value.close()
  })
  handleCloseEmit()
}
const handleCloseEmit = () => {
  emit('close')
}

const time = ref(30 * 60 * 1000)
const payInfoNew = ref({})

const clickCopyAmount = async () => {
  try {
    const text = t('CurrencySymbol') + payInfoNew.value.amount || 0
    await navigator.clipboard.writeText(text)
    showToast(t('deposito-index.common.copySuccess'))
  } catch (error) {
    console.log('error ----- ', error)
  }
}

const clickCopyPublic = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    showToast(t('deposito-index.common.copySuccess'))
  } catch (error) {
    console.log('error ----- ', error)
  }
}

// 充值金额过滤
const filterAmount = (amount) => {
  // 分转元
  const newAmount = amount / 100
  return newAmount.toFixed(2)
}

const changeTime = (event) => {
  console.log('changeTime...')
}

//
const filterCreateTimeLShow = (value) => {
  // time 时间戳 显示成 日/月/年 时分秒
  if (!value) return ''

  // 如果是时间戳，转换为毫秒
  let timestamp = value
  if (typeof value === 'string' && /^\d+$/.test(value)) {
    // 判断是秒还是毫秒
    timestamp = value.length === 10 ? parseInt(value) * 1000 : parseInt(value)
  } else if (typeof value === 'number') {
    // 判断是秒还是毫秒
    timestamp = value.toString().length === 10 ? value * 1000 : value
  }

  const date = new Date(timestamp)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}
const filterQcdoeNumShow = (value) => {
  const length = 40
  if (value && value.length > length) {
    // 切割当前字符串的最后length位数
    return '**' + value.substring(value.length - length, value.length - 1)
  }
  return '*******'
}

// 刷新充值状态
watch(
  () => props.payInfo.status,
  (val) => {
    console.log('watch val ----- ', val)
    if (val) {
      playStatus.value = val
    }
  }
)

const statusKeyMap = {
  '00': 'processing', // 支付中
  90: 'pending', // 待扣款
  99: 'pendingSubmission', // 待提交
  '06': 'pendingConfirmation', // 待确认
  '01': 'success', // 成功
  '02': 'failed', // 失败
  '04': 'refunded', // 退款
  '05': 'rejected', // 驳回
}
const playStatus = ref('00')
const statusText = computed(() => {
  const key = statusKeyMap[playStatus.value]
  return key ? t(`deposito-index.depositoPay.status.${key}`) : ''
})
const playStatusLoadding = ref(false)
const refreshPlayStatus = async () => {
  playStatusLoadding.value = true
  try {
    const res = await rechargeQueryOrderInfoApi({
      order_no: props.payInfo.merchantOrderId,
    })
    if (res.code == 1) {
      playStatus.value = res.data.status
    }
  } catch (error) {
    // console.log('error ----- ', error)
  } finally {
    playStatusLoadding.value = false
  }
}

const emit = defineEmits(['close'])

defineExpose({
  open,
  close,
})
</script>

<style lang="less" scoped>
.deposito-pay-popup {
  background-color: var(--deposito-pay-view-bg);
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;

  .bodyer-container {
    padding: 10px;

    .order-container + .order-container {
      margin-top: 10px;
    }
    .order-container {
      padding: 10px;
      background-color: var(--deposito-pay-card-bg);
      border: 1px solid var(--deposito-pay-card-border);
      border-radius: 6px;

      &.info {
        .order-num-box {
          text-align: right;

          .value {
            font-size: 14px;
            color: var(--deposito-pay-card-order-id);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
          }
          .pay-copy {
            width: 15px;
            min-width: 15px;
            height: 16px;
            margin-left: 5px;
          }
        }
        .pay-num-box {
          margin-top: 10px;
          padding-top: 20px;
          border-top: 1px solid var(--deposito-pay-card-divider);

          .label {
            font-size: 14px;
            color: var(--deposito-pay-card-label);
          }
          .pay-num {
            font-size: 18px;
            font-weight: 700;
            color: var(--deposito-pay-card-amount);
          }
        }
      }

      &.main {
        padding-bottom: 20px;

        .prompt-container {
          font-size: 14px;
          font-weight: 700;
          color: var(--deposito-pay-card-value);
          text-align: center;

          p {
            text-indent: 20px;
          }
        }

        .qr-code-container {
          margin: 20px auto 40px;
          padding: 10px;
          width: calc(100% - 28px);
          background: var(--deposito-pay-qr-bg);
        }

        .copiar-button {
          margin: 0 auto;
          width: calc(100% - 28px);
        }
      }
    }
  }

  .pix-icon-box {
    margin: 20px auto 40px;
    height: 90px;

    .pix-icon {
      width: 264px;
    }
  }
}

.deposito-pay-popup {
  .pay-bg {
    width: 375px;
    height: 119px;
    position: relative;
  }

  .pay-overlay {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 12px;
    width: 100%;
    height: 100%;
    color: #000;
  }

  .pay-content {
    height: 100%;
  }

  .payment-amount-label {
    font-size: 14px;
    color: #383838;
    font-weight: bold;
  }

  .payment-amount-value {
    font-weight: 900;
    font-size: 28px;
    color: #383838;
  }

  .payment-info-container {
    position: relative;
    width: 375px;
    margin-top: 20px;
    height: 38px;
    padding: 10px;
  }

  .clabe-container {
    div:first-child {
      font-size: 12px;
      color: #a4a7aa;
    }

    div:last-child {
      font-size: 14px;
      color: #fff;
    }
  }

  .copy-button {
    width: 78px;
    position: relative;
    height: 28px;
    background: linear-gradient(130deg, #8bffc0 0%, #9aea73 100%);
    border-radius: 18px;
    padding: 5px 10px;
  }

  .copy-icon {
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }

  .copy-text {
    font-size: 12px;
    color: #000;
  }

  .instruction-step {
    width: 355px;
    background: #2b2d34;
    border-radius: 8px;
    margin: 10px;
    padding: 10px 0;
  }

  .instruction-icon {
    margin-left: 16px;
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  .instruction-text {
    .instruction-step-label {
      color: #a4a7aa;
      font-size: 12px;
    }

    .instruction-step-value {
      color: #fff;
      font-size: 12px;
    }
  }
}
</style>
